import { useEffect, useMemo, useState } from "react";
import { Alert, Container, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import iconApps from "../../assets/images/icon/icon.png";
import {
  processLeaveApprovalToken,
  processOvertimeApprovalToken,
  processScheduleApprovalToken,
} from "../../api/ApprovalActionApi";

import { tr } from "../../i18n";
const ApprovalActionPage = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const token = searchParams.get("token") || "";
  const type = (searchParams.get("type") || "").toLowerCase();
  const actionParam = searchParams.get("action") || "";
  const leaveCategoryParam = searchParams.get("leave_category") || "";
  const isLoggedIn = useMemo(() => {
    try {
      return Boolean(localStorage.getItem("userProfile"));
    } catch (error) {
      return false;
    }
  }, []);

  const action = useMemo(() => {
    if (actionParam.toLowerCase() === "approved") {
      return "Approved";
    }
    if (actionParam.toLowerCase() === "decline") {
      return "Decline";
    }

    return "";
  }, [actionParam]);

  useEffect(() => {
    let cancelled = false;

    const runApproval = async () => {
      if (!token) {
        setStatus("error");
        setMessage(tr("approvals:approval_token_is_missing"));
        setIsLoading(false);
        return;
      }

      if (!action) {
        setStatus("error");
        setMessage(tr("approvals:approval_action_is_invalid"));
        setIsLoading(false);
        return;
      }

      if (!["leave", "overtime", "schedule"].includes(type)) {
        setStatus("error");
        setMessage(tr("approvals:approval_type_is_invalid"));
        setIsLoading(false);
        return;
      }

      const handler =
        type === "leave"
          ? processLeaveApprovalToken
          : type === "overtime"
            ? processOvertimeApprovalToken
            : processScheduleApprovalToken;

      const response = await handler({
        token,
        action,
        leave_category: leaveCategoryParam || undefined,
      });

      if (cancelled) {
        return;
      }

      if (response?.status === 200) {
        setStatus("success");
        setMessage(
          response.message || tr("approvals:approval_has_been_processed_successfully"),
        );
      } else {
        setStatus("error");
        setMessage(response?.message || tr("approvals:approval_process_failed"));
      }

      setIsLoading(false);
    };

    runApproval();

    return () => {
      cancelled = true;
    };
  }, [token, type, action, leaveCategoryParam]);

  return (
    <>
      <Helmet>
        <title>{tr("approvals:approval_action")}</title>
      </Helmet>

      <div className="center-content">
        <Container className="box-shadow">
          <img
            src={iconApps}
            alt={tr("approvals:sewoork_logo")}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              width: "100px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />

          <h2 className="text-center">{tr("approvals:approval_action")}</h2>

          {isLoading ? (
            <div className="text-center py-4">
              <Spinner animation="border" role="status" />
              <p className="mt-3 mb-0">{tr("approvals:processing_your_request")}</p>
            </div>
          ) : (
            <>
              <Alert variant={status === "success" ? "success" : "danger"}>
                {(message || "").replace(/<br\s*\/?>/gi, " ")}
              </Alert>

              <div className="d-grid gap-2 mt-3">
                {isLoggedIn ? (
                  <Link to="/dashboard" className="btn btn-primary">
                    {tr("approvals:go_to_dashboard")}
                  </Link>
                ) : (
                  <Link to="/login" className="btn btn-primary">
                    {tr("approvals:go_to_login")}
                  </Link>
                )}

                <Link to="/login" className="btn btn-outline-secondary">
                  {tr("approvals:open_login_page")}
                </Link>
              </div>
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default ApprovalActionPage;
